import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { requestProviderDone, requestProviderFailed, setProvider } from './provider.action'

export interface State {
	isLoaded: boolean
	info?: any
}

export const defaultState: State = {
	isLoaded: false,
	info: undefined,
}

export default reducerWithInitialState<State>(defaultState)
	.cases([setProvider, requestProviderDone], (state, payload) => ({
		...state,
		isLoaded: true,
		info: payload,
	}))
	.case(requestProviderFailed, (state) => ({
		...state,
		isLoaded: true,
		info: undefined,
	}))
	.default((state) => state)